const styles = (theme) => ({
  tabs: {
    display: 'flex',
  },

  tab: {
    color: '#b2bcc7',
    cursor: 'pointer',
    display: 'flex',
    fontSize: '15px',
    fontWeight: 500,
    height: '50px',
    margin: '0px 14px',
    textAlign: 'center',
    '&:first-child': {
      marginLeft: '0px',
    },
  },

  tabSelected: {
    color: theme.palette.primary.dark,
  },

  label: {},

  labelSelected: {
    '&:after': {
      backgroundImage: `linear-gradient(to bottom, ${theme.palette.primary.dark}, #6c86d9)`,
      borderRadius: '11px',
      bottom: '-2px',
      content: '""',
      display: 'block',
      height: '3px',
      left: '0px',
      position: 'relative',
      width: '100%',
    },
  },
});

export default styles;
